import { BaseProviderInstanceResourceModel } from '../../../../models/base-provider-instance-resource-model';
import { ReportProfileUser } from '../../../../models/profile/report-profile-user';

export class OnePageModelBase {
  providerInstanceResource: BaseProviderInstanceResourceModel;
  begin: Date;
  end: Date;
  userProfile: ReportProfileUser;
}
